import React from "react";
import demoImg from "../../images/hireDeveloper/demoImg.jpg";

const userData = [
  {
    images: demoImg,
    name: "Ketan Patel",
    position: "Sr. Full stack developer",
    text: "I was able to get the type of work I was already looking for with the help of the company and their team at the highest possible pay scale. Thanks, Hire Remote Team.",
  },
  {
    images: demoImg,
    name: "Ketan Patel",
    position: "Sr. Full stack developer",
    text: "I was able to get the type of work I was already looking for with the help of the company and their team at the highest possible pay scale. Thanks, Hire Remote Team.",
  },
  {
    images: demoImg,
    name: "Ketan Patel",
    position: "Sr. Full stack developer",
    text: "I was able to get the type of work I was already looking for with the help of the company and their team at the highest possible pay scale. Thanks, Hire Remote Team.",
  },
  {
    images: demoImg,
    name: "Ketan Patel",
    position: "Sr. Full stack developer",
    text: "I was able to get the type of work I was already looking for with the help of the company and their team at the highest possible pay scale. Thanks, Hire Remote Team.",
  },
  {
    images: demoImg,
    name: "Ketan Patel",
    position: "Sr. Full stack developer",
    text: "I was able to get the type of work I was already looking for with the help of the company and their team at the highest possible pay scale. Thanks, Hire Remote Team.",
  },
];

const Testimonial = () => {
  return (
    <>
      <section className="testimonialSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="heading">
                <h3 data-aos="slide-right">
                  Hire Remote Team's <span>Success Stories</span>
                </h3>
                <p data-aos="slide-up">
                  Take a look at what people who got hired through Hire Remote
                  Team have to say!
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                {userData.map((each, i) => (
                  <div className="details" data-aos="zoom-in" key={i}>
                    <div className="images">
                      <img src={each.images} alt="Hire Dedicated Developers" />
                    </div>
                    <h5>{each.name}</h5>
                    <span>{each.position}</span>
                    <p>{each.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
